export const todoTranslations = {} as const;

export type TodoTranslations = typeof todoTranslations;
export type TodoTranslationDictionary = TodoTranslations[keyof TodoTranslations];

export const getTodoTranslationDictionary = (_language: string): TodoTranslationDictionary =>
  ({} as TodoTranslationDictionary);

export const translateTodo = (
  _language: string,
  key: string,
  _params?: Record<string, unknown>,
): string => key;

export type TodoTranslationType = Record<string, never>;

export default todoTranslations;
